export default __webpack_public_path__ + "static/media/co2wizardLogo.2e54701a.png";